import config from '../../../config/config';
import deleteRequest from '../base/delete';
import getRequest from '../base/get';
import patchRequest from '../base/patch';
import postRequest from '../base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}
 
export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.cpo.accountApiUrl}api/partner/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list for export
   * @param {any} query - The query
   */
  fetchUsersExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.cpo.accountApiUrl}api/partner/v1/users/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Single user
   * @param {any} id - The id
   */
  fetchUser: (id: string): Promise<any> =>
    getRequest(`${config.cpo.accountApiUrl}api/partner/v1/users/${id}`),
  /**
   * Fetch the Single user
   * @param {any} id - The id
   */
  fetchUserActivityLogs: (id: string): Promise<any> =>
    getRequest(`${config.notificationApiUrl}api/partner/v1/general-log/activityLog/${id}`),
  /**
   * Create the user api call function
   * @param {any} data - The user details
   * @returns {any} A promise that resolves with the creation response
   */
  createUser: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.cpo.accountApiUrl}api/partner/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Update the user api call function
   * @param {any} id - The user ID to edit
   * @param {any} data - The updated user data
   * @returns {any} A promise that resolves with the update response
   */
  editUser: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.cpo.accountApiUrl}api/partner/v1/users/${id}`, {
      ...parameters,
    });
  },
  /**
   * Update the user profile image
   * @param {any} data - The profile image data
   * @returns {any} A promise that resolves with the response
   */
  editUserProfileImage: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.cpo.accountApiUrl}api/partner/v1/users/profile-image`,
      {
        ...parameters,
      },
      true,
    );
  },
  /**
   * Update the user government id
   * @param {any} data - The government ID data
   * @returns {any} A promise that resolves with the response
   */
  editUserGovernmentId: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.cpo.accountApiUrl}api/partner/v1/users/government-id`,
      {
        ...parameters,
      },
      true,
    );
  },
  /**
   * Delete the user api call function
   * @param {any} id - The user ID to delete
   * @returns {any} A promise that resolves with the response
   */
  deleteUser: (id: String): Promise<any> => {
    return deleteRequest(`${config.cpo.accountApiUrl}api/partner/v1/users/${id}`);
  },

  /**
   * Fetch user API
   * @returns {any} A promise that resolves with the list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.cpo.accountApiUrl}api/partner/v1/users/list-filters`);
  },
};
